// @owners { team: patients-team }
import { ActionSheetContext, ActionSheetV2, Body, Button, Column, LgPadding } from '@alto/design-system';
import { ContactUs } from '@alto/features';
import React, { useContext } from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';

export const VerificationBlockedActionSheet = () => {
  const { closeActionSheet } = useContext(ActionSheetContext);

  return (
    <ActionSheetV2
      title="Give us a call"
      analyticsName="verification_blocked"
      buttons={[
        <Button
          key="close-button"
          label="Close"
          accessibilityLabel="Press to close"
          type="primary"
          onPress={closeActionSheet}
        />,
      ]}
    >
      <LgPadding>
        <Column gap="SM">
          <Body>
            Based on the information provided, you may already have an {getCompanyName()} account. For your security,
            please{' '}
            <ContactUs
              origin="verification_blocked"
              type="link"
              method="phone"
            />{' '}
            to complete your account setup.
          </Body>
        </Column>
      </LgPadding>
    </ActionSheetV2>
  );
};
